import { useLayoutEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { benefitDetailUrl } from '#/domains/landing/utils/benefitDetailUrl';

/** SPA in-app navigation only (Link) — full page loads use index.html inline redirect (vite plugin). */
export default function BenefitDetailRedirect() {
  const { serviceSeqNo } = useParams<{ serviceSeqNo: string }>();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!serviceSeqNo) {
      navigate('/', { replace: true });
      return;
    }
    window.location.assign(benefitDetailUrl(serviceSeqNo));
  }, [serviceSeqNo, navigate]);

  return null;
}
